import PropTypes from 'prop-types'
import React from 'react'
import queryString from 'query-string'

import { isAndroid } from 'src/services/browser_detection'

import Button from 'components/common/Button'
import SvgIcon from 'components/common/SvgIcon'

import styles from './download-app-banner.scss'
import iosIcon from 'src/assets/icons/hobnob_iOS_icon.svg'
import androidIcon from 'src/assets/icons/app-icon-android-small.png'

export default class DownloadAppBanner extends React.Component {
  _downloadLink = () => {
    const { eventToken, invitationToken } = this.props

    const base = process.env.BRANCH_INSTALL_BANNER_LINK

    const params = {}
    if (eventToken) {
      params.event_token = eventToken
    }
    if (invitationToken) {
      params.invitation_token = invitationToken
    }

    return `${base}?${queryString.stringify(params)}`
  }

  _renderText () {
    if (isAndroid()) {
      return this._renderAndroidBanner()
    } else {
      return this._renderIosBanner()
    }
  }

  _renderAppIcon () {
    if (isAndroid()) {
      return <img src={androidIcon} />
    } else {
      return <SvgIcon icon={iosIcon} />
    }
  }

  render () {
    const downloadUrl = this._downloadLink()

    return (
      <div className={styles['container']}>
        <a
          href={downloadUrl}
          className={styles['icon']}
        >
          {this._renderAppIcon()}
        </a>
        <div className={styles['text']}>
          <div className={styles['app-name']}>
            Hobnob - Event Invitations
          </div>
          <div className={styles['description']}>
            Get 5 FREE credits for your own event
          </div>
        </div>
        <Button
          wrapperElement={'a'}
          className={styles['download-btn']}
          href={downloadUrl}>
          GET APP
        </Button>
      </div>
    )
  }
}

DownloadAppBanner.propTypes = {
  eventToken: PropTypes.string,
  invitationToken: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/global/DownloadAppBanner.jsx